import tennesseeJacksonBrightGlobe from '../Media/BigDial/BigDial-BrightGlobe06.svg';

const PlantSources = [
    {
        "name":{
            "plantName": "jackson2",
            "displayName": "Jackson",
            "databaseName": "jackson2/"
        },
        "location": "tennessee",
        "displayLocation": 'Tennessee',
        "brightGlobe" : tennesseeJacksonBrightGlobe
    },    
    {
        "name":{
            "plantName": "paris",
            "displayName": "Puryear",
            "databaseName": "paris/"
        },
        "location": "tennessee",
        "displayLocation": 'Tennessee',
        "brightGlobe" : tennesseeJacksonBrightGlobe
    }
]

export default PlantSources